import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

export default function LogoBanner() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div
      className="w-full h-full flex items-center gap-3 px-4"
      style={{ background: isDark ? '#0b1020' : '#ffffff' }}
    >
      {/* ── Hexagon icon ── */}
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
      >
        <defs>
          <linearGradient id="hexGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#4f8ff8" />
            <stop offset="100%" stopColor="#6366f1" />
          </linearGradient>
          {isDark && (
            <filter id="glow" x="-30%" y="-30%" width="160%" height="160%">
              <feGaussianBlur stdDeviation="2.5" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          )}
        </defs>

        {/* Hexagon outline */}
        <polygon
          points="18,2 32,10 32,26 18,34 4,26 4,10"
          fill={isDark ? 'rgba(79,143,248,0.08)' : 'rgba(79,143,248,0.06)'}
          stroke="url(#hexGrad)"
          strokeWidth="1.8"
          filter={isDark ? 'url(#glow)' : undefined}
        />

        {/* Lightning bolt */}
        <path
          d="M20 8L13 19.5H18.5L16 28L23 16.5H17.5L20 8Z"
          fill="url(#hexGrad)"
          filter={isDark ? 'url(#glow)' : undefined}
        />
      </svg>

      {/* ── Text block ── */}
      <div className="flex flex-col leading-none">
        {/* Main name */}
        <div className="flex items-baseline gap-0">
          <span
            className="text-[18px] font-bold tracking-tight"
            style={{ color: isDark ? '#f1f5fb' : '#0b1020', fontFamily: 'Inter, system-ui, sans-serif' }}
          >
            Catalyst
          </span>
          <span
            className="text-[18px] font-bold tracking-tight"
            style={{
              background: 'linear-gradient(135deg, #4f8ff8 0%, #6366f1 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontFamily: 'Inter, system-ui, sans-serif',
            }}
          >
            IQ
          </span>
        </div>

        {/* Subtitle */}
        <span
          className="text-[9px] tracking-[0.18em] uppercase mt-[3px]"
          style={{
            color: isDark ? '#a3b6cc' : '#94a3b8',
            fontFamily: '"JetBrains Mono", "Fira Code", monospace',
          }}
        >
          Momentum Scanner
        </span>
      </div>

      {/* ── Right accent dots ── */}
      <div className="ml-auto flex flex-col items-end gap-[3px] shrink-0">
        <div className="w-[3px] h-[3px] rounded-full" style={{ background: '#4f8ff8', opacity: 0.7 }} />
        <div className="w-[3px] h-[3px] rounded-full" style={{ background: '#a78bfa', opacity: 0.7 }} />
        <div className="w-[3px] h-[3px] rounded-full" style={{ background: '#10d98e', opacity: 0.7 }} />
      </div>
    </div>
  );
}
